import { NgModule } from '@angular/core';
import {RouterModule, Routes} from '@angular/router';

/***
 *  manual imports
 */
import {PagesComponent} from './pages/pages.component';
import { ModerationComponent } from './pages/moderation/moderation.component';
import { ContenusComponent } from './pages/moderation/contenus/contenus.component';
import {ReportingComponent} from './pages/reporting/reporting.component';
import {AccueilComponent} from './pages/accueil/accueil.component';
import { FacturationComponent } from './pages/facturation/facturation.component';
import {RetourComponent} from './pages/retour/retour.component';
import { HistoriqueComponent } from './pages/historique/historique.component';
import { SupervisionComponent } from './pages/supervision/supervision.component';
import { AdministrationComponent } from './pages/administration/administration.component';
import {PlaningComponent} from './pages/planing/planing.component';
import { CqComponent } from './pages/cq/cq.component';
import { DetailsComponent } from './pages/historique/details/details.component';
import { ListeValidationComponent } from './pages/reporting/liste-validation/liste-validation.component';
import {ListeReportingGlobaleComponent} from './pages/reporting/liste-reporting-globale/liste-reporting-globale.component';
import {ListeReportingOpComponent} from './pages/reporting/liste-reporting-op/liste-reporting-op.component';
import { LoginComponent } from './login/login.component';
import { AuthGuard } from './shared/';
import {ListeRejeterComponent} from './pages/reporting/liste-rejeter/liste-rejeter.component';
import { HasEnCoursGuard } from './shared/guard/has-en-cours.guard';
import { CheckLoginGuard } from './shared/guard/check-login.guard';
import { ExcelComponent } from './pages/excel/excel.component';
import { BrouillonsComponent } from './pages/brouillons/brouillons.component';
import { EchantillonageComponent } from './pages/echantillonage/echantillonage.component';
import { PerformanceComponent } from './pages/performance/performance.component';
import { PasswordComponent } from './pages/administration/password/password.component';
import { VisualisationComponent } from './pages/visualisation/visualisation.component';
import { LogsComponent } from './pages/logs/logs.component';
import { EnvoiComponent } from './pages/envoi/envoi.component';

const routes: Routes = [
  {
    path : '',
    component: PagesComponent,
    canActivate: [CheckLoginGuard, AuthGuard],
    children: [
      {
        path : '',
        component: ModerationComponent,
        canActivate: [HasEnCoursGuard],
      },
      {
        path : 'moderation',
        component: ModerationComponent,
        canActivate: [HasEnCoursGuard],
      },
      {
        path : 'traitement/:moderation',
        component: ContenusComponent,
      },
      {
        path: 'reporting',
        component: ReportingComponent
      },
      {
        path: 'accueil',
        component: AccueilComponent
      },
      {
        path: 'facturation',
        component: FacturationComponent
      },
      {
        path: 'retour',
        component: RetourComponent
      },
      {
        path: 'historique',
        component: HistoriqueComponent
      },
      {
        path: 'supervision',
        component: SupervisionComponent
      },
      {
        path: 'administration',
        component: AdministrationComponent
      },
      {
        path: 'planing',
        component: PlaningComponent
      },
      {
        path: 'cq/:moderation',
        component: CqComponent
      },
      {
        path: 'details/:historique',
        component: DetailsComponent
      },
      {
        path: 'reporting-nb-attente',
        component: ListeValidationComponent
      },
      {
        path: 'reporting-globale',
        component: ListeReportingGlobaleComponent
      },
      {
        path: 'reporting-op',
        component: ListeReportingOpComponent
      },
      {
        path: 'reporting-nb-rejeter',
        component: ListeRejeterComponent
      },
      {
        path : 'import',
        component: ExcelComponent
      },
      {
        path : 'brouillons',
        component: BrouillonsComponent
      },
      {
        path : 'echantillonage',
        component: EchantillonageComponent
      },
      {
        path: 'performance',
        component: PerformanceComponent
      },
      {
        path: 'password',
        component: PasswordComponent
      },
      {
        path: 'visualisation/:moderation',
        component: VisualisationComponent
      },
      {
        path: 'logs',
        component: LogsComponent
      },
      {
        path: 'envoi',
        component: EnvoiComponent
      },
    ]
  },
  {
    path: 'login',
    component: LoginComponent
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes)
  ],
  exports : [RouterModule]
})
export class AppRoutingModule { }
